import { render, staticRenderFns } from "./ProviderIconWide.vue?vue&type=template&id=21d803ea&scoped=true"
import script from "./ProviderIconWide.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderIconWide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderIconWide.vue?vue&type=style&index=0&id=21d803ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d803ea",
  null
  
)

export default component.exports